




























































































































import { Vue, Component, Lifecycle, Watch, Prop, p, Mixin } from "av-ts";
import { ITopic, ISearch } from "../../interfaces/models";

import QuestionService from "../../services/QuestionService";
import TopicService from "../../services/TopicService";
import Fetcher from "../../services/Fetcher";
import responsiveMixin from "../../responsiveMixin";
import PageLoader from "../util/PageLoader.vue";

@Component({
    components: {
        PageLoader
    }
})
export default class QuestionSearch extends mixin(responsiveMixin, Vue) {

    timeoutId: number | undefined = undefined;
    nextSearchRequest: Function| undefined = undefined;

    @Prop
    page = p<number>({
        default: 1
    });
    @Prop
    totalQuestions = p<number>({
        default: 0
    });

    pTopics: ITopic[] = [];
    pCurrentPageSize = 25;

    get currentPageSize() {
        return this.pCurrentPageSize;
    }

    set currentPageSize(newSize: number) {
        this.pCurrentPageSize = newSize;
        if (this.search) {
            this.search.pageSize = newSize;
        }
    }

    get searchableFields() {
        return [{
            name: "Sort By",
            id: "sortField",
            type: "select",
            sort: true,
            options: [{
                name: "",
                value: ""
            }, {
                name: "Recommended",
                value: "recommended"
            }, {
                name: "Correctness",
                value: "correctness"
            }, {
                name: "Effectiveness",
                value: "effectiveness"
            }, {
                name: "Created Time",
                value: "created_time"
            }, {
                name: "Responses",
                value: "responses"
            }, {
                name: "Comments",
                value: "comments"
            }]
        }, {
            name: "Filter Topics",
            id: "filterTopics",
            type: "multiselect",
            options: this.topics.map(topic => ({
                name: topic.name,
                value: topic.id
            }))
        }, {
            name: "Filter Questions",
            id: "filterField",
            type: "select",
            options: [{
                name: "All Questions",
                value: ""
            }, {
                name: "Unanswered Questions",
                value: "unanswered"
            }, {
                name: "Answered Questions",
                value: "answered"
            }, {
                name: "My Questions",
                value: "authored"
            }, {
                name: "My Deleted Questions",
                value: "deleted"
            }, {
                name: "Imported Questions",
                value: "imported"
            }
            /*, {
                name: "Room for Improvement",
                value: "improve"
            }*/]
        }, {
            name: "Search",
            id: "query",
            type: "text"
        }];
    }

    search: ISearch | undefined = undefined;

    updateCourseTopics(newTopics: ITopic[]) {
        this.pTopics = newTopics;
        QuestionService.getSearchCacheForCourse()
            .then(x => {
                this.search = x;
                this.currentPageSize = x.pageSize;
            });
    }

    get topics() {
        return this.pTopics;
    }

    @Lifecycle
    created() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateCourseTopics);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateCourseTopics);
    }

    sort() {
        if (this.search !== undefined) {
            this.search.sortDesc = !this.search.sortDesc;
        }
    }

    applyFilters() {
        const search = Object.assign({}, this.search, { page: this.page, pageSize: this.currentPageSize });
        if (search.filterTopics.length == 0) {
            search.filterTopics = this.topics.map(x => x.id);
        }
        QuestionService.search(search)
            .then(searchResult => {
                this.timeoutId = undefined;
                if (this.nextSearchRequest != undefined) {
                    this.nextSearchRequest();
                    this.nextSearchRequest = undefined;
                } else {
                    if (this.search !== undefined) {
                        QuestionService.setSearchCacheForCourse(this.search);
                    }
                    // Only bubble through the most recent search
                    this.$emit("searched", searchResult);
                }
            });
    }

    @Watch("page")
    pageChanged(_newVal: number, _oldVal: number) {
        this.startSearch();
    }

    @Watch("currentPageSize")
    pageSizeChanged(_newVal: number, _oldVal: number) {
        this.startSearch();
    }

    @Watch("search", { deep: true })
    searchWatch(_newValue: ISearch | undefined, _oldValue: ISearch| undefined) {
        this.startSearch();
    }

    startSearch() {
        if (this.timeoutId === undefined) {
            this.timeoutId = window.setTimeout((() => this.applyFilters()), 10);
        } else {
            this.nextSearchRequest = () => {
                this.timeoutId = window.setTimeout((() => this.applyFilters()), 10);
            };
        }
    }

    get searchItemClass() {
        return {
            "searchItem": !this.mobileMode,
            "mobileSearchItem": this.mobileMode
        };
    }

    nextPage(pagination: { size: number, page: number }) {
        this.page = pagination.page;
        this.currentPageSize = pagination.size;
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionSearch.vue